import React from 'react';
import { Grid } from 'semantic-ui-react';
// import { NavLink } from 'react-router-dom';
import logo from '../../common/assets/WEnergy-FSM-logo.png';
import LogoutComponent from './LogoutComponent';
import { actionRecordUtils } from '../../HelperMethods/LocalStorageUtils';

function TopHeader() {
  const joynAILink = `https://${window.location.hostname}/#`;
  const fdsLink = `https://${window.location.hostname}/admin/home/login.html`;
  const [headerState, setheaderState] = React.useState(null);
  const getConfigfromlink = async (link) => {
    try {
      const response = await fetch(link);
      return response.json();
    } catch (error) {
      return error;
    }
  };

  const headerLinkfetch = async () => {
    try {
      const { REACT_APP_ENVIRONMENT: env } = process.env;
      const { hostname } = window.location || {};
      const tempOrigin = hostname === 'localhost' ? 'joyn2-dev' : hostname;
      const origin = hostname === 'localhost' ? 'joyn2-dev' : tempOrigin.split('.')[0];
      const suffix = env === 'prod' ? '' : `-${env}`;
      const configLink = `https://joynfsm${suffix}.s3.us-west-2.amazonaws.com/config/${origin}.json`;
      const awsConfigFile = await getConfigfromlink(configLink);
      if (awsConfigFile) {
        const headerLinks = awsConfigFile.headerLinks || {};
        setheaderState(headerLinks);
        // localStorage.setItem('HEADER_DETAILS', JSON.stringify(headerLinks));
      }
    } catch (e) {
      console.log(e);
    }
  };
  React.useEffect(() => {
    headerLinkfetch();
  }, []);

  // let headerLinks = null;
  // const tempheaderLinks = localStorage.getItem('HEADER_DETAILS');
  // if (tempheaderLinks) {
  //   headerLinks = JSON.parse(tempheaderLinks);
  // }

  return (
    <Grid style={{ margin: '0px', padding: '0px', borderBottom: '1px solid #e8e8e8' }}>
      <Grid.Row style={{ margin: '0px', padding: '0px' }}>
        <Grid.Column width={4} style={{ margin: '0px', padding: '0px' }}>
          <div className="nav-row" style={{ paddingTop: '5px', height: '55px' }}>
            <img src={logo} style={{ height: '100%', width: '335px' }} />
          </div>
        </Grid.Column>
        <Grid.Column width={8} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="nav-row" style={{ paddingTop: '10px', height: '40px' }}>
            {headerState && headerState.fdgadmin && (
              <a href={fdsLink} target="_blank" rel="noopener noreferrer" style={{ lineHeight: '0px' }}>
                <div className="nav-bar-item navbar-item-topheader">FDG</div>
              </a>
            )}
            {headerState && headerState.analytics && (
              <a target="_blank" rel="noopener noreferrer" href={joynAILink} style={{ lineHeight: '0px' }}>
                <div className="nav-bar-item navbar-item-topheader">Analytics</div>
              </a>
            )}
          </div>
        </Grid.Column>
        <Grid.Column width={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {!actionRecordUtils.GET_ACTION_RECORD() && <LogoutComponent />}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
}

export default TopHeader;
